import React from 'react';
import { Button } from '../ui/button';
import { Home, Minus, Plus } from 'lucide-react';

export default function SizeSlider({ size, onSizeChange }) {
  const handleDecrease = () => {
    if (size > 500) {
      onSizeChange(size - 100);
    }
  };

  const handleIncrease = () => {
    if (size < 5000) {
      onSizeChange(size + 100);
    }
  };

  return (
    <div className="space-y-6 size-slider">
      <div className="text-center">
        <div className="size-slider__icon">
          <Home className="w-8 h-8 text-white" />
        </div>
        <h3 className="size-slider__heading">Building Size</h3>
        <p className="size-slider__value">
          <span key={size} className="inline-block jiggle">{size.toLocaleString()}</span>
          <span className="size-slider__value-unit"> sq ft</span>
        </p>
      </div>

      <div className="px-4">
        <div className="size-slider__controls">
          <Button
            onClick={handleDecrease}
            disabled={size <= 500}
            variant="outline"
            size="icon"
            className="btn-circle-lg control-emerald"
          >
            <Minus size={60} strokeWidth={4} className="u-teal-600" />
          </Button>

          <span className="size-slider__step">±100 sq ft</span>

          <Button
            onClick={handleIncrease}
            disabled={size >= 5000}
            variant="outline"
            size="icon"
            className="btn-circle-lg control-emerald"
          >
            <Plus size={60} strokeWidth={4} className="u-teal-600" />
          </Button>
        </div>

        <div className="relative">
          <input
            type="range"
            min="500"
            max="5000"
            step="100"
            value={size}
            onChange={(e) => onSizeChange(parseInt(e.target.value))}
            className="w-full appearance-none slider"
          />
          <div className="size-slider__range-labels">
            <span>500 sq ft</span>
            <span>5,000 sq ft</span>
          </div>
        </div>
      </div>
    </div>
  );
}
